import {observer} from "mobx-react";
import {useStore} from "../../../stores/Store";
import React, {BaseSyntheticEvent} from "react";
import {Accordion, AccordionSummary, Checkbox, FormControlLabel, FormGroup, Typography} from "@mui/material";
import {ExpandMore} from "@mui/icons-material";

export default observer(function ReedsFilter(){
    const {AccordionStore, LanguageStore} = useStore();
    const {currentLanguageMessages} = LanguageStore;
    const {setFilteredFamReeds, setFilteredTamReeds, setFilteredTurboReeds, setFilteredDurallReeds, filteredTamReeds,
        filteredDurallReeds, filteredFamReeds, filteredTurboReeds} = AccordionStore;
    const handleChange = (event: BaseSyntheticEvent) => {
        if(event.target.name === 'durall') setFilteredDurallReeds(event.target.checked);
        else if(event.target.name === 'fam') setFilteredFamReeds(event.target.checked);
        else if(event.target.name === 'tam') setFilteredTamReeds(event.target.checked);
        else if(event.target.name === 'turbo') setFilteredTurboReeds(event.target.checked);
    }

    return (
        <Accordion variant={'outlined'}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>{currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.title}</Typography>
            </AccordionSummary>
            <FormGroup sx={{ml: 2}} onChange={handleChange}>
                <FormControlLabel
                    control={
                        <Checkbox
                            name={'durall'}
                            disabled={filteredFamReeds || filteredTurboReeds || filteredTamReeds}
                            value={!filteredDurallReeds}
                            color={'secondary'}
                            checked={filteredDurallReeds}
                        />
                    }
                    label={currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.durall}
                    key={'durall'}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            name={'tam'}
                            disabled={filteredFamReeds || filteredTurboReeds || filteredDurallReeds}
                            value={!filteredTamReeds}
                            color={'secondary'}
                            checked={filteredTamReeds}
                        />
                    }
                    label={currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.tam}
                    key={'tam'}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            name={'fam'}
                            disabled={filteredDurallReeds || filteredTurboReeds || filteredTamReeds}
                            value={!filteredFamReeds}
                            color={'secondary'}
                            checked={filteredFamReeds}
                        />
                    }
                    label={currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.fam}
                    key={'fam'}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            name={'turbo'}
                            disabled={filteredFamReeds || filteredDurallReeds || filteredTamReeds}
                            value={!filteredTurboReeds}
                            color={'secondary'}
                            checked={filteredTurboReeds}
                        />
                    }
                    label={currentLanguageMessages.AccordionsPage.Filter.ReedsFilter.turbo}
                    key={'turbo'}
                />
            </FormGroup>
        </Accordion>
    )
})